import React from 'react'

export default ({ piAttachments, resource }) => {
  return (
    <div className="row">
      <div className="col-lg-3">
        <b>{resource.SupplierPurchaseInvoice}:</b>
      </div>
      <div className="col-lg-9">
        {piAttachments.map((attachment, index) => (
          <div key={index}>
            <a href={attachment.downloadUrl} download={attachment.filename}>
              {attachment.filename}
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}
